import { animate, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, EventEmitter, HostBinding, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { MatIntroService, MatIntroStepExtend } from './mat-intro.service';

@Component({
    selector: 'mat-intro',
    templateUrl: './mat-intro.component.html',
    styleUrls: ['./mat-intro.component.scss'],
    animations: [
        trigger('panel', [
            transition(':enter', [
                style({opacity: 0, transform: 'translate(var(--mat-intro-panel-translate-x), var(--mat-intro-panel-translate-y)) scale(0.8)'}),
                animate('120ms cubic-bezier(0, 0, .2, 1)', style({
                    opacity: 1, 
                    transform: 'translate(var(--mat-intro-panel-translate-x), var(--mat-intro-panel-translate-y)) scale(1)'
                })),
            ]),
            transition(':leave', [
                animate('100ms 25ms linear', style({opacity: 0}))
            ])
        ])
    ]
})
export class MatIntroComponent implements OnDestroy {

    @ViewChild('panelElement', {read: ElementRef, static: true}) panelElementRef: ElementRef<HTMLElement>;

    @HostBinding('style.pointerEvents') get pointerEvent(): string {
        return (this.step.next instanceof Function || this.step.canInteract) ? 'none' : 'auto';
    }

    @Input() step: MatIntroStepExtend;

    @Output() onNext: EventEmitter<void> = new EventEmitter();

    top: number = 0;
    left: number = 0;
    width: number = 0;
    height: number = 0;

    windowWidth: number = window.innerWidth;
    windowHeight: number = window.innerHeight;

    panelTop: string = '0%';
    panelLeft: string = '0%';

    faces: string[] = [
        'Slightly Smiling Face',
        'Thinking Face',
        'Neutral Face',
        'Face with Hand Over Mouth'
    ];

    face: string = this.faces[0];
    faceChooser;

    @HostBinding('style.--mat-intro-panel-translate-x') translateX: string = '-50%';
    @HostBinding('style.--mat-intro-panel-translate-y') translateY: string = '-50%';
    @HostBinding('class.mat-intro-highlight') get highlight() { return this.width > 0 && this.height > 0; };

    constructor(public intro: MatIntroService) {

        if(this.faceChooser) {
            clearInterval(this.faceChooser);
            delete this.faceChooser;
        }

        this.faceChooser = setInterval(() => this.face = this.faces[Math.floor((Math.random() * this.faces.length))], 10000);
    }

    updatePosition ({top, left, width, height}: {top?: number, left?:number, width?: number, height?: number}) {

        this.top = top;
        this.left = left;
        this.width = width;
        this.height = height;

        if(width === 0 && height === 0) {
            this.panelTop = '0%';
            this.panelLeft = '0%';
            this.translateX = '-50%';
            this.translateY = '-50%';
        
        } else {
            this.panelTop = 'calc(100% + 16px)';
            this.panelLeft = '0%';
            this.translateX = '0%';
            this.translateY = '0%';

            const panelBounding = this.panelElementRef.nativeElement.getBoundingClientRect();

            if((left + panelBounding.width) > (this.windowWidth * 3/4)) {
                this.panelLeft = '100%';
                this.translateX = '-100%';
            }

            if((top + height + panelBounding.height) > (this.windowHeight * 3/4) || this.step.position === 'above') {
                this.panelTop = '-16px';
                this.translateY = '-100%';
            }

            if((top + height + panelBounding.height) > this.windowHeight && (top - panelBounding.height) < 0 || this.step.position === 'after') {
                this.panelTop = '0%';
                this.panelLeft = 'calc(100% + 16px)';
                this.translateY = '0%';
            }
        }
    }

    ngOnDestroy(): void {
        
        if(this.faceChooser) {
            clearInterval(this.faceChooser);
            delete this.faceChooser;
        }
    }
}
